import { recaptchaType } from './contracts'
import { HiddenRecaptcha } from './styled'

export const Recaptcha = ({ id }: recaptchaType): JSX.Element => {
  return <HiddenRecaptcha id={id} />
}
